<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import notify from "../../../../../../Script/notify"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  export let json = {}

  const timeZoneOffsetMilliseconds = new Date().getTimezoneOffset() * 60000 // Convert minutes to milliseconds

  let expiryDate = json.date ? new Date(new Date(json.date).getTime() - timeZoneOffsetMilliseconds).toISOString().split("T")[0] : ""
  // console.log(json.date)
  // console.log(new Date(json.date).toString())
  // console.log(expiryDate)
  // let expiryDate = json.options.expireOn ? new Date(json.options.expireOn).toString() : ""

  /**
   * @typedef {Object} notificationExpired
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notificationExpired}
   */
  let notificationExpired = {
    close() {},
  }
  /**
   * Function for Validating the expired date
   */
  const isDateExpired = (e) => {
    try {
      notificationExpired.close()
      if (!e.target.value) {
        json.date = ""
        dispatch("dateChanged", json)
        return
      }
      const value = e.target.value
      let expirationDate = new Date(value)
      let currentDate = new Date()

      // Remove the time component from both dates
      expirationDate.setHours(0, 0, 0, 0)
      currentDate.setHours(0, 0, 0, 0)

      // Compare the dates
      if (expirationDate <= currentDate) {
        throw "You've selected an older date. Please choose a future date as the expiration date."
      }

      // console.log(expiryDate)

      json.date = new Date(expiryDate).toISOString()
      // console.log(json.date)

      dispatch("dateChanged", json)
      showDateInput = false
    } catch (error) {
      json.date = ""
      expiryDate = ""
      const info = "PAGE: Start Bulk Upload\nEVENT: While validating expiry date on input change"
      notificationExpired = notify.danger(error, info)
      dispatch("dateChanged", json)
    }
  }

  let showDateInput = false
</script>

<div class="space-y-3 rounded-r-md border-l-4 border-green-500 bg-[#F4F8FB] px-6 py-3 dark:bg-bodyblack">
  <h1 class="font-semibold dark:text-white">Row {json.string}</h1>
  <div class="flex flex-col gap-3 mobile:flex-row mobile:items-center mobile:justify-end">
    {#if showDateInput}
      <div class="flex h-[37.6px] w-full mobile:justify-end">
        <div class="relative h-full w-full mobile:w-[150px]">
          <input type="date" id="dateInput" bind:value={expiryDate} on:change={isDateExpired} placeholder="Enter date" style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;" class="absolute z-20 h-full w-full rounded-md border border-[#a0a1a580] bg-transparent px-3 pl-5 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-200 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:text-white sm:text-sm" />
          <div class="absolute right-3 top-2 z-10 text-gray-800 dark:text-slate-200">
            <i class="fa-solid fa-calendar-days" />
          </div>
        </div>
      </div>
    {:else if expiryDate}
      <div class="flex flex-col tracking-tighter dark:text-white mobile:items-center md:flex-row md:justify-end md:gap-2">
        <span class="text-red-500">Expires&nbsp;On:</span>
        <span class="font-mono">{new Date(json.date).toString()}</span>
      </div>
    {:else}
      <h1 class="flex justify-end dark:text-white">No Expiry value provided</h1>
    {/if}
    <button on:click={() => (showDateInput = !showDateInput)} data-tooltip={showDateInput ? "Confirm" : "Reset Date"} tooltip-position="top" type="button" class="flex h-[37.6px] items-center justify-center rounded-md border border-gray-500 font-medium text-gray-500 hover:border-blue-600 hover:bg-blue-500 mobile:aspect-square {showDateInput ? 'hover:border-green-600 hover:bg-green-500 ' : 'hover:border-blue-600 hover:bg-blue-500 '} hover:text-white">
      <i class="fa-solid fa-{showDateInput ? 'check' : 'repeat'}" />
    </button>
  </div>
</div>

<style lang="postcss">
  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
